<div
  class="account-type-container"
  [formGroup]="form"
  [class.error-border]="
    form.controls.accounts.invalid && form.controls.accountType.value === accountTypeId && formSubmitted
  ">
  <div class="radio-container flex-column">
    <div class="radio-container">
      <app-radio-button-input
        formControlName="accountType"
        [hidden]="accounts?.length === 0"
        [controlId]="radioControlId"
        [value]="accountTypeId"
        [name]="'accountType'" />
      <app-form-option-label [labelFor]="radioControlId" i18n>
        {{ accountTypeId | accountTypeName }} Accounts
      </app-form-option-label>
    </div>
    <span class="hidden-funds-label" *ngIf="accountsHidden" i18n> Accounts without invested funds are hidden. </span>
    <div formArrayName="accounts" class="account-container" *ngIf="accounts.controls?.length">
      <div class="account" *ngFor="let account of accounts.controls" [formGroup]="account">
        <app-checkbox-input
          [hidden]="accounts.controls?.length === 1"
          formControlName="selected"
          [controlId]="account.controls.id.value.toString()" />
        <div class="d-flex flex-column gap-2">
          <app-form-option-label class="d-flex" [labelFor]="account.controls.id.value.toString()" i18n>
            {{ account.controls.name.value }}
          </app-form-option-label>
          <span>{{ account.controls.id.value }}</span>
        </div>
        <span class="total-balance">{{ account.controls.totalBalance.value | currency }}</span>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="form.controls.accounts.invalid && form.controls.accountType.value === accountTypeId && formSubmitted"
  class="error mb-4 mt-3"
  i18n>
  You must select at least 1 account to continue
</div>
